<nz-result
  nzStatus="success"
  nzTitle="Successfully Logged into Your Chrome Extension!"
  nzSubTitle="You Can Safely Close This Tab"
>
  <div nz-result-extra>
    <button nz-button nzType="primary" (click)="onCloseTabClick()">Close Tab</button>
  </div>
</nz-result>
